<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-11-06 20:17:07
 * @LastEditTime: 2023-07-07 10:46:11
 * @Description: 
-->
<template>
    <div class="footer">
        <div class="xian"></div>
        <div class="flex mg">
            <div>
                <img class="img" src="@/assets/img/dibubg.png" alt="">
            </div>
        </div>
        <div class="xian"></div>
    </div>
    <div class="txt">Copyright © 2022-2023. 智普信科技 ｜ 京ICP备09027907号-7</div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'index',
    setup() {
        const data = reactive({})
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.txt{
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #C2C6CA;
    line-height: 22px;
    // padding-top: 25px;
}
.footer{
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .xian{
        width: 450px;
        height: 1px;
        background: rgba(0,20,42,0.06);
    }
    .mg{
        margin: 0 12px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .txt{
        font-size: 12px;
        font-weight: 400;
        color: #C2C6CA;
        line-height: 22px;
    }
    .img{
        width: 145px;
        height: auto;
        // margin-left: 9px;
        // transform: translateY(4px);
    }
}
</style>